/**
 * anonymousModalButtons.tsx
 */
import ActivateButton from '@components/elements/buttons/ui/activateButton';
import ModalButton from '@components/elements/buttons/ui/modalButton';
import Container from '@components/atoms/container/modalButtons';
import Focus from '@shared/types/enums/focus';
import List from '@components/sections/list/list';
import Modals from '@shared/types/enums/modals';
import { AnonymousModalButtonsProps as Props } from '@shared/types/props/modal';
import { clearModal, setModal } from '@shared/store/slices/modal.slice';
import { loginAction } from '@shared/actions/flow';
import { useAppDispatch } from '@shared/store/hooks';
import { useEffect } from 'react';
import {
  filterFocus,
  popFocus,
  pushFocus,
} from '@shared/store/slices/focus.slice';

/**
 * Displays the anonymous modal buttons.
 */
export default function AnonymousModalButtons({ allowZapping = false }: Props) {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(pushFocus(Focus.MODAL_BUTTONS));
    dispatch(filterFocus(Focus.MODAL_BUTTONS));
    return () => {
      dispatch(popFocus());
    };
  }, []);

  const activateButtonAction = () =>
    dispatch(setModal(Modals.ACTIVATE_GENERIC));
  const loginButtonAction = () => loginAction();
  const cancelButtonAction = () => dispatch(clearModal());

  return (
    <Container>
      <List focus={Focus.MODAL_BUTTONS}>
        <ActivateButton action={activateButtonAction} index={0} />
        <ModalButton
          action={loginButtonAction}
          addMargin={true}
          index={1}
          tip='MODAL.ANONYMOUS.ACCOUNT'
          text='MODAL.ANONYMOUS.BUTTONS.LOGIN'
        />
        {!allowZapping ? (
          <ModalButton
            releaseAction={cancelButtonAction}
            index={2}
            text='MODAL.ANONYMOUS.BUTTONS.CANCEL'
          />
        ) : null}
      </List>
    </Container>
  );
}
